import React, { useState } from "react";
import { Button, Form, FormGroup, Label } from "reactstrap";
import { Controller } from "react-hook-form";

const ColorInput = ({
    fieldName,
    control,
    fieldLabel,
    error,
    disabled,
    defaultValue = []
}) => {
    const [colors, setColors] = useState(defaultValue);

    const addColor = () => {
        setColors([...colors, "#000000"]);
    };

    const removeColor = (index) => {
        const newColors = colors.filter((_, i) => i !== index);
        setColors(newColors);
    };

    const updateColor = (index, color) => {
        const newColors = [...colors];
        newColors[index] = color;
        setColors(newColors);
    };

    return (
        <>
            <FormGroup>
                <Label htmlFor="recipient-name" className="col-form-label">
                    {fieldLabel}
                </Label>
                <Controller
                    name={fieldName}
                    control={control}
                    render={({ field }) => (
                        <div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '10px' }}>
                                {colors.map((color, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                        <input
                                            type="color"
                                            value={color}
                                            onChange={(e) => {
                                                updateColor(index, e.target.value);
                                                const newColors = [...colors];
                                                newColors[index] = e.target.value;
                                                field.onChange(newColors);
                                            }}
                                            disabled={disabled}
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                border: 'none',
                                                borderRadius: '4px',
                                                cursor: disabled ? 'not-allowed' : 'pointer'
                                            }}
                                        />
                                        <span style={{ fontSize: '12px', color: '#666' }}>
                                            {color}
                                        </span>
                                        <button
                                            type="button"
                                            onClick={() => {
                                                removeColor(index);
                                                field.onChange(colors.filter((_, i) => i !== index));
                                            }}
                                            disabled={disabled}
                                            style={{
                                                background: '#ff4757',
                                                color: 'white',
                                                border: 'none',
                                                borderRadius: '50%',
                                                width: '20px',
                                                height: '20px',
                                                cursor: disabled ? 'not-allowed' : 'pointer',
                                                fontSize: '12px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))}
                            </div>

                            <Button
                                type="button"
                                color="primary"
                                size="sm"
                                onClick={() => {
                                    addColor();
                                    field.onChange([...colors, "#000000"]);
                                }}
                                disabled={disabled}
                                style={{ marginBottom: '10px' }}
                            >
                                + Add Color
                            </Button>

                            {/* Hidden input to store the array value */}
                            <input
                                type="hidden"
                                {...field}
                                value={JSON.stringify(colors)}
                            />

                            {/* Display the colors array */}
                            {/* <div style={{
                                marginTop: '10px',
                                padding: '10px',
                                backgroundColor: '#f8f9fa',
                                borderRadius: '4px',
                                fontSize: '12px'
                            }}>
                                <strong>Selected Colors:</strong> {JSON.stringify(colors)}
                            </div> */}
                        </div>
                    )}
                />
                {error && (
                    <p
                        role="alert"
                        style={{
                            color: "red",
                            display: "flex",
                            flexDirection: "start",
                            paddingLeft: "10px",
                            fontSize: "12px",
                        }}
                    >
                        {error?.message}
                    </p>
                )}
            </FormGroup>
        </>
    );
};

export default ColorInput;